import { computed, type Ref } from 'vue'

import {
  PURCHASE_ORDER_STATUS_LOOKUP,
  type PurchaseOrderStatus,
} from '@/constants/persoplan'
import scssVariables from '@/assets/scss/scssVariables'
import { lookup } from '@/utilities/misc'
import type { Nilable } from '@/types/misc'

export type { PurchaseOrderStatus } from '@/constants/persoplan'

interface Options {
  status: Ref<Nilable<PurchaseOrderStatus>>
}

const colors = {
  requisition: scssVariables.color['status-purchaseOrder-requisition'],
  requested: scssVariables.color['status-purchaseOrder-requested'],
  ordered: scssVariables.color['status-purchaseOrder-ordered'],
  canceled: scssVariables.color['status-purchaseOrder-canceled'],
} as const satisfies Record<PurchaseOrderStatus, string>

export function getPurchaseOrderStatus(options: { id: Nilable<string> }) {
  if (!options.id) return

  const id = Number(options.id)
  if (!Number.isInteger(id)) return

  return lookup(id, PURCHASE_ORDER_STATUS_LOOKUP)
}

export function usePurchaseOrderStatus(options: Options) {
  const classes = computed(() => {
    if (!options.status.value) return

    return {
      [`is-statusPurchaseOrder-${options.status.value}`]: true,
    }
  })

  const color = computed(() => {
    if (!options.status.value) return

    return colors[options.status.value]
  })

  return {
    classes,
    color,
  }
}
